const initialState = {
  status: "invalid",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "STATIC_PAGES_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "STATIC_PAGES_SUCCESS":
      return {
        ...state,
        status: "success",
        ...action
      };
    case "STATIC_PAGES_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    default:
      return state;
  }
};
